import axios from '../axios';
import * as models from './models';

export function Proofs(hyejooRequestInit: models.IHyejooRequest): Promise<models.ProofsHyejooResponse> {
    return axios.get('/proofs', {
        params: new models.HyejooRequest(hyejooRequestInit),
    }).then(r => models.ProofsHyejooResponse.fromJSON(r.data));
}
